
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 23 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.216 18.438a2.438 2.438 0 00-1.103 4.601v2.893h2.023V23.13a2.437 2.437 0 00-.92-4.692z"}}),_c('path',{attrs:{"d":"M19.216 12.784V8.455A8.293 8.293 0 0011.126 0a8.293 8.293 0 00-8.092 8.455v4.329H0v17.193A2.023 2.023 0 002.023 32h18.205a2.023 2.023 0 002.022-2.023V12.784h-3.034zM5.056 8.455a6.27 6.27 0 016.07-6.432 6.27 6.27 0 016.067 6.432v4.329H5.057V8.455zM2.024 29.977v-15.17h18.205v15.17H2.023z"}})])
          )
        }
      }
    